export enum LanguageCode {
  Afar = 'aa',
  Abkhazian = 'ab',
  Avestan = 'ae',
  Afrikaans = 'af',
  Akan = 'ak',
  Amharic = 'am',
  Aragonese = 'an',
  Arabic = 'ar',
  Assamese = 'as',
  Avaric = 'av',
  Aymara = 'ay',
  Azerbaijani = 'az',
  Bashkir = 'ba',
  Belarusian = 'be',
  Bulgarian = 'bg',
  Bihari = 'bh',
  Bislama = 'bi',
  Bambara = 'bm',
  Bengali = 'bn',
  Tibetan = 'bo',
  Breton = 'br',
  Bosnian = 'bs',
  Catalan_Valencian = 'ca',
  Chechen = 'ce',
  Chamorro = 'ch',
  Corsican = 'co',
  Cree = 'cr',
  Czech = 'cs',
  ChurchSlavic_OldSlavonic_ChurchSlavonic_OldBulgarian_OldChurchSlavonic = 'cu',
  Chuvash = 'cv',
  Welsh = 'cy',
  Danish = 'da',
  German = 'de',
  Divehi_Dhivehi_Maldivian = 'dv',
  Dzongkha = 'dz',
  Ewe = 'ee',
  Greek_ModernAfter1453 = 'el',
  English = 'en',
  Esperanto = 'eo',
  Spanish = 'es',
  Estonian = 'et',
  Basque = 'eu',
  Persian = 'fa',
  Fulah = 'ff',
  Finnish = 'fi',
  Fijian = 'fj',
  Faroese = 'fo',
  French = 'fr',
  Western_Frisian = 'fy',
  Irish = 'ga',
  Gaelic_Scottish_Gaelic = 'gd',
  Galician = 'gl',
  Guarani = 'gn',
  Gujarati = 'gu',
  Manx = 'gv',
  Hausa = 'ha',
  Hebrew = 'he',
  Hindi = 'hi',
  Hiri_Motu = 'ho',
  Croatian = 'hr',
  Haitian_HaitianCreole = 'ht',
  Hungarian = 'hu',
  Armenian = 'hy',
  Herero = 'hz',
  Interlingua_InternationalAuxiliaryLanguageAssociation = 'ia',
  Indonesian = 'id',
  Interlingue_Occidental = 'ie',
  Igbo = 'ig',
  Sichuan_Yi_Nuosu = 'ii',
  Inupiaq = 'ik',
  Ido = 'io',
  Icelandic = 'is',
  Italian = 'it',
  Inuktitut = 'iu',
  Japanese = 'ja',
  Javanese = 'jv',
  Georgian = 'ka',
  Kongo = 'kg',
  Kikuyu_Gikuyu = 'ki',
  Kuanyama_Kwanyama = 'kj',
  Kazakh = 'kk',
  Kalaallisut_Greenlandic = 'kl',
  Central_Khmer = 'km',
  Kannada = 'kn',
  Korean = 'ko',
  Kanuri = 'kr',
  Kashmiri = 'ks',
  Kurdish = 'ku',
  Komi = 'kv',
  Cornish = 'kw',
  Kirghiz_Kyrgyz = 'ky',
  Latin = 'la',
  Luxembourgish_Letzeburgesch = 'lb',
  Ganda = 'lg',
  Limburgan_Limburger_Limburgish = 'li',
  Lingala = 'ln',
  Lao = 'lo',
  Lithuanian = 'lt',
  LubaKatanga = 'lu',
  Latvian = 'lv',
  Malagasy = 'mg',
  Marshallese = 'mh',
  Maori = 'mi',
  Macedonian = 'mk',
  Malayalam = 'ml',
  Mongolian = 'mn',
  Marathi = 'mr',
  Malay = 'ms',
  Maltese = 'mt',
  Burmese = 'my',
  Nauru = 'na',
  Bokmål_Norwegian_Norwegian_Bokmål = 'nb',
  Ndebele_North_North_Ndebele = 'nd',
  Nepali = 'ne',
  Ndonga = 'ng',
  Dutch_Flemish = 'nl',
  Norwegian_Nynorsk_Nynorsk_Norwegian = 'nn',
  Norwegian = 'no',
  Ndebele_South_South_Ndebele = 'nr',
  Navajo_Navaho = 'nv',
  Chichewa_Chewa_Nyanja = 'ny',
  OccitanPost1500 = 'oc',
  Ojibwa = 'oj',
  Oromo = 'om',
  Oriya = 'or',
  Ossetian_Ossetic = 'os',
  Panjabi_Punjabi = 'pa',
  Pali = 'pi',
  Polish = 'pl',
  Pushto_Pashto = 'ps',
  Portuguese = 'pt',
  Quechua = 'qu',
  Romansh = 'rm',
  Rundi = 'rn',
  Romanian_Moldavian_Moldovan = 'ro',
  Russian = 'ru',
  Kinyarwanda = 'rw',
  Sanskrit = 'sa',
  Sardinian = 'sc',
  Sindhi = 'sd',
  NorthernSami = 'se',
  Sango = 'sg',
  Sinhala_Sinhalese = 'si',
  Slovak = 'sk',
  Slovenian = 'sl',
  Samoan = 'sm',
  Shona = 'sn',
  Somali = 'so',
  Albanian = 'sq',
  Serbian = 'sr',
  Swati = 'ss',
  Sotho_Southern = 'st',
  Sundanese = 'su',
  Swedish = 'sv',
  Swahili = 'sw',
  Tamil = 'ta',
  Telugu = 'te',
  Tajik = 'tg',
  Thai = 'th',
  Tigrinya = 'ti',
  Turkmen = 'tk',
  Filipino = 'tl',
  Tswana = 'tn',
  Tonga_TongaIslands = 'to',
  Turkish = 'tr',
  Tsonga = 'ts',
  Tatar = 'tt',
  Twi = 'tw',
  Tahitian = 'ty',
  Uighur_Uyghur = 'ug',
  Ukrainian = 'uk',
  Urdu = 'ur',
  Uzbek = 'uz',
  Venda = 've',
  Vietnamese = 'vi',
  Volapük = 'vo',
  Walloon = 'wa',
  Wolof = 'wo',
  Xhosa = 'xh',
  Yiddish = 'yi',
  Yoruba = 'yo',
  Zhuang_Chuang = 'za',
  Chinese = 'zh',
}
